










































import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';
import {i18nAllObject} from '@/utils/i18n';
import {readExcelFile} from '@/utils/excel';
import { pattern } from '@/const/regex';

const extraManagementCdRegex = new RegExp(pattern['extra-management-cd'], 'g');

@Component
export default class StockExcelUpload extends Vue {
  private uploadFile = [];
  private uploadFileName = '';

  private removeFile() {
    (this.$refs.excelFile as any).value = null;
    this.uploadFile = [];
    this.uploadFileName = '';
  }

  private changeFile(event: any) {
    let files = event.target.files;
    let file = files[0];

    if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
      alert(this.$t('STOCK_MANAGEMENT_EXCEL_NAME_ERROR'));
      (this.$refs.excelFile as any).value = null;
      this.uploadFileName = '';
    } else {
      this.uploadFile = files;
      this.uploadFileName = file.name;
    }
  }
  private async save() {
    if (this.uploadFile.length == 0) {
      alert(this.$t('STOCK_MANAGEMENT_SELECT_FILE'));
      return;
    }
    const keyMapJson = {
      stockNo: 'STOCK_MANAGEMENT_STOCKNO',
      modifyStockType: 'STOCK_MANAGEMENT_MODIFY_STOCK_TYPE',
      modifyStockCnt: 'STOCK_MANAGEMENT_MODIFY_STOCK_CNT',
      optionManagementCd: 'STOCK_MANAGEMENT_OPTIONMANAGEMENTCD',
      extraManagementCd: 'STOCK_MANAGEMENT_EXTRAMANAGEMENTCD',
      mallNo: 'STOCK_MANAGEMENT_MALLNO',
      mallName: 'STOCK_MANAGEMENT_GRIDHEADER_MALLNAME',
      mallProductNo: 'STOCK_MANAGEMENT_GRIDHEADER_MALLPRODUCTNO',
      productManagementCd: 'STOCK_MANAGEMENT_GRIDHEADER_PRODUCTMANAGEMENTCD',
      productName: 'STOCK_MANAGEMENT_PRODUCTNAME',
      mallOptionNo: 'STOCK_MANAGEMENT_GRIDHEADER_MALLOPTIONNO',
      optionNameAndValue: 'STOCK_MANAGEMENT_GRIDHEADER_OPTIONNAMEANDVALUE',
      stockCnt: 'STOCK_MANAGEMENT_EXCELTITLE_CURRENTSTOCK'
    };
    let columns = i18nAllObject(this, keyMapJson);
    await readExcelFile(this.uploadFile[0], columns, await this.saveExcel);
  }

  private async saveExcel(excelData: any) {
    let failRow = excelData.filter((row, i) => i > 0 && row.stockNo === undefined);
    if (failRow.length > 0) {
      alert(this.$t('STOCK_MANAGEMENT_EXCEL_NO_DATA'));
      return;
    }

    let data = excelData
      .filter((row, i) => i > 0)
      .map((row) => {
        let handlerType = 'UNRESOLVED';
        const extraManagementCode = row.extraManagementCd?.toString() ?? '';
        
        if (row.modifyStockType === '') {
          handlerType = 'NOT_CHANGED';
        } else if (row.modifyStockType == '1') {
          handlerType = 'ADJUST';
        } else if (row.modifyStockType == '2') {
          handlerType = 'EDIT';
        }

        let rowData: any = {
          mallName: row.mallName,
          handlerType,
          productName: row.productName,
          optionNameAndValue: row.optionNameAndValue,
          handlerTypeOriginInput: row.modifyStockType,
          extraManagementCode,
          optionManagementCode: row.optionManagementCd || '',
          currentStock: row.stockCnt,
          stock: row.modifyStockCnt,
          optionNo: row.mallOptionNo,
          mallNo: row.mallNo,
          productManagementCode: row.productManagementCd || '',
          productNo: row.mallProductNo,
          stockNo: row.stockNo
        };

        if (row.modifyStockType) {
          if (!row.modifyStockCnt || Number(row.modifyStockCnt) === NaN) {
            rowData.handlerType = 'UNRESOLVED';
            rowData.stock = 0;
          }
        }

        return rowData;
      });
    if (data.length === 0) {
      alert(this.$t('STOCK_MANAGEMENT_EXCEL_DATA_ERROR'));
      return;
    }
    let response = await this.$api.putStocksExcel({data});
    let resInfo: any = {
      okFlg: true
    };
    if (response.headers['content-type'] === 'application/json') {
      alert(this.$t('STOCK_MANAGEMENT_LAST_SAVED'));
    } else {
      const myBlob = new Blob([response.data as any], {type: 'application/octet-stream'});
      const qrUrl = window.URL.createObjectURL(myBlob);
      resInfo = {
        okFlg: false,
        data,
        qrUrl
      };
    }

    let callBackName = sessionStorage.getItem('uploadCallBack');
    if (callBackName) {
      $(window.opener.location).attr('href', `javascript:window.${callBackName}(${JSON.stringify(resInfo)});`);
    }

    self.close();
  }

  private async mounted() {
    addClass(document.getElementById('container'), 'width-720');
    this.$nextTick(() => {
      popupResize(750, 460);
    });
  }

  private beforeDestroy() {
    removeClass(document.getElementById('container'), 'width-720');
  }
}
